// extracted by mini-css-extract-plugin
module.exports = {"videoError":"style_videoError__2kZDK","videoContainer":"style_videoContainer__-36Ya","videoCountDown":"style_videoCountDown__l_om9"};